<template>
  <a-card :bordered='false'>
    <app-warp :title='form.title' color='#efefef'>
      <template #app-content>
        <div class="couponBox  width100 s_po_re ">
          <div class="coupon_one ">
            <img :src="form.img?oss+form.img:require('@/assets/images/assets/pickUpTopDefault.png')" alt="" style="width:100%">
          </div>
          <div class="coupon_two p-tb0-lr10 s_bf">
            <p class="height-51 s_bor_b_cd9 s_flex_bian_c s_c666 fz-13" style="border-color: #f0f0f0;">附近适用门店
              <RightOutlined />
            </p>
            <p class="height-46 s_bor_b_cd9 s_flex_bian_c s_c333 fz-13" style="border-color: #f0f0f0;">使用方式:线下门店提货 </p>
            <p class="height-46 s_bor_b_cd9 s_flex_bian_c s_c333 fz-13" style="border-color: #f0f0f0;" v-if="form.phone">咨询电话:{{form.phone}} </p>
            <p class="height-46 s_bor_b_cd9 s_flex_bian_c s_c333 fz-13" style="border-color: #f0f0f0;" >有效期: xxxx-xx-xx </p>
            <div class=" s_bor_b_cd9  s_c333 fz-13" style="border-color: #f0f0f0;padding-top:10px;min-height:46px" v-if="form.explain">使用说明:
              <div v-html="form.explain" class="detailContent"></div>
            </div>
          </div>
        </div>
      </template>
      <template #app-sider>
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" style="margin-left:25px">
          <div class="mb25">
            <a-form-item ref="title" label="页面名称" name="title" help=''>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.title" placeholder='请输入名称' :maxlength='8' :suffix="form.title.length+'/8'" />
                </a-col>
                <a-col :span="12">
                  <p>限8个字内</p>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="image_url" label="宣传图片" name="image_url">
              <material :groupType="1" :image="form.img" :max="1" v-on:handlechoose="(data) => {form.img = data;}
              " v-on:handledel="(data) => {form.img = '';}"  :defaultImg="require('@/assets/images/assets/pickUpTopDefault.png')"/>
            </a-form-item>
            <a-form-item ref="phone" label="咨询电话" name="phone" help=''>
              <a-input v-model:value="form.phone" placeholder='请输入咨询电话'  style="width:200px"></a-input>
            </a-form-item>
          </div>
          <a-form-item ref="explain" label="使用说明" name="explain" style="margin-bottom: 0;">
            <quill v-model:value="form.explain" :content="JSON.parse(JSON.stringify(form.explain))" :height="700" style="height:1000px" />
          </a-form-item>
        </a-form>
      </template>
    </app-warp>
    <div class="s_flex_center">
      <a-button @click="provide()" class="  m-t-20 m-r-20">返回</a-button>
      <a-button type="primary" class="  m-t-20 " @click="onSubmit">保存</a-button>
    </div>
  </a-card>
  <a-modal :keyboard="false" title="选择门店" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='goodList' :checkout="true"></selectGood>
  </a-modal>
</template>
<script>
import { RightOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { getVoucherDetailTemplate, updateVoucherDetailTemplate } from "@/api/assets";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import config from "@/config";
import store from "@/store";
// 初始化默认筛选项数值
let defForm = {
  title: "提货券详情",
  img: "",
  phone: "",
  explain: "",
};
export default {
  components: {
    RightOutlined,
  },
  props: {
    id: Number || String,
  },
  setup(props, { emit }) {
    const $route = inject("$route");
    const $router = inject("$router");
    const momentTime = inject("momentTime");



    const form = ref({ ...defForm });
    const state = reactive({
      card: "",
      info: store.state.user.info,
      showGood: false,
      goodList: [],
      time: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules: {
        title: [{ required: true, message: "请输入提货券名称" }],
      },
    });
    const ruleForm = ref();

    //获取详情
    const getMore = async (id) => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getVoucherDetailTemplate({ id: props.id })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        if (res.data.id) {
          form.value = res.data;
        }
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    //提交
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(() => {
          confirmSubmit();
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    //提交请求
    const confirmSubmit = async () => {
      const hide = message.loading("正在加载中...", 0);
      var res = await updateVoucherDetailTemplate({ ...form.value, id: props.id })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        message.success(res.msg);
        setTimeout(() => {
          $router.go(-1);
        }, 2000);
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    onMounted(() => {
      if ($route.query.type == "edit") {
        getMore($route.query.id);
      }
    });
    const provide = () => {
      emit("setpsTreeProvide", 1);
    };
    return {
      form,
      ...toRefs(state),
      oss: config.oss[process.env.VUE_APP_type],
      ruleForm,
      onSubmit,
      provide,
    };
  },
};
</script>
<style lang="less" scoped>
.couponBox .coupon_one {
  border-bottom: 1px dashed #dedede;
  position: relative;
}

.couponBox .coupon_one .ban {
  width: 10px;
  height: 20px;
  background-color: #efefef;
  display: block;
  position: absolute;
  bottom: -10px;
  z-index: 1;
}

.couponBox .coupon_one .ban.right {
  right: -2px;
  -webkit-border-radius: 20px 0 0 20px;
  border-radius: 20px 0 0 20px;
}

.couponBox .coupon_one .ban.left {
  left: -2px;
  -webkit-border-radius: 0 20px 20px 0;
  border-radius: 0 20px 20px 0;
}

.couponBox:after {
  content: "";
  width: 100%;
  height: 4px;
  background: url("/assets/images/ta.png") -9px 0 / auto 100%;
  position: absolute;
  top: -4px;
  left: 0;
}

.logo {
  border-radius: 100%;
  position: absolute;
  left: 50%;
  top: -25px;
  transform: translateX(-50%);
}

.coverBox {
  width: 274px;
  height: 107px;
  border: 1px dashed #ddd;
}
</style>
<style lang="less" >
.detailContent {
  img {
    width: 100%;
  }
}
</style>